import React, { useState } from 'react';

import './Checklist.scss';
import { link } from '../../helpers/link';
import icons from '../../shared/assets/icons/redesign';

const { ChevronRight, Check } = icons;

export default function Checklist(props) {
  const { data = {} } = props.useQuery(props.getListQuery,
    { variables: { name: props.listName } });

  const { data: userItems = {} } = props.useQuery(props.getUserListItem,
    { variables: { username: props.username }, skip: !props.username });

  const savedItems = userItems.getUserListItem || [];

  const isSavedList = props.type === 'saved';

  const list = data.getList && data.getList.items || props.list;

  const [popup, toggleFilterPopup] = useState(false);

  const [changedItems, setChangedItems] = useState(new Set());

  const [filteredTypes, updateFilteredTypes] = useState(new Set());

  const [lastChangesIsSaved, setLastChangesIsSaved] = useState(false);

  const types = list && list.reduce((types, item) => {
    const type = types.find(type => type.name === item.type);

    if (type) return type.quantity++, types;

    types.push({ name: item.type, quantity: 1 });

    return types;
  }, []);

  return list ? (
    <section className="checklist">
      <div className="checklist-content">
        {props.filters && <div className="checklist-filters checklist-desktop">
          <p onClick={() => toggleFilterPopup(!popup)}>
            <Filter />Filteren
          </p>

          {!!filteredTypes.size && <ul className="checklist-filtered-types">
            {[...filteredTypes].map((type, idx) =>
              <li key={idx}>
                {type}

                <span onClick={() => removeType(type)}>&times;</span>
              </li>)}
          </ul>}

          {popup && <ul className="checklist-filter-popup">
            {types.map((item, idx) =>
              <li
                key={idx}
                onClick={() => addType(item.name)}>
                <p>{item.name}</p>

                <span>{item.quantity} artikelen</span>
              </li>)}
          </ul>}
        </div>}

        <ul className="checklist-items">
          {filteredTypes.size
            ? [...filteredTypes].map(type =>
              listItem(list.find(entry => entry.type === type)))
            : [...list]
              .sort((a, b) => a.orderKey - b.orderKey)
              .map(item => listItem(item))}
        </ul>
      </div>

      {isSavedList ?
        <button
          onClick={() => removeAllItems()}
          className="checklist-button">
          Checklists verwijderen
        </button> :

        <button
          className="checklist-button"
          onClick={() => !lastChangesIsSaved && saveChangedItems()}>
          {lastChangesIsSaved ? 'Opgeslagen' : 'Opslaan'}
        </button>
      }
    </section>
  ): null;

  function listItem(item) {
    return (
      <li key={item.id} className="checklist-item">
        <div className="checklist-item-checkbox-wrap">
          <input
            type="checkbox"
            onClick={() => setItem(item.id)}
            className="checklist-item-checkbox"
            defaultChecked={setCheckedValue(item.id)}
          />

          <span className="checklist-item-check-icon-wrap">
              <Check className="checklist-item-check-icon" />
          </span>
        </div>

        {(item.content && item.content.uri)
          ? link(<p className="checklist-item-name">{item.title}</p>,
            `/${item.content.uri}`)
          : <p className="checklist-item-name">{item.title}</p>}

        {item.content && item.content.uri &&
          <div className="checklist-item-link-wrap">
            {link(
              <div className="checklist-item-link">
                <ChevronRight className="checklist-item-link-icon" />
              </div>,
              `/${item.content.uri}`
            )}
          </div>}
      </li>
    );
  }

  function addType(type) {
    updateFilteredTypes(filteredTypes.add(type));

    toggleFilterPopup(!popup);
  }

  function removeType(type) {
    const newSet = new Set(filteredTypes);

    newSet.delete(type);

    updateFilteredTypes(newSet);
  }

  function saveChangedItems() {
    if (!props.username)
      return location.href = props.config.LOGIN_URL;

    changedItems.forEach(item =>
      props.setUserListItem({ variables: { listItemId: +item } }));
    setChangedItems(new Set());

    setLastChangesIsSaved(true);
  }

  function removeAllItems() {
    props.list.forEach(item => setItem(item.id));
  }

  function setItem(id) {
    if (isSavedList) return props.setUserListItem({ variables:
      { listItemId: +id } });

    const newSet = new Set(changedItems);

    if (changedItems.has(id)) newSet.delete(id);
    else newSet.add(id);

    setChangedItems(newSet);

    setLastChangesIsSaved(false);
  }

  function setCheckedValue(id) {
    if (isSavedList) return true;
    if (!props.username) return false;

    return savedItems.find(entry =>
      entry.value === 'Yes' && entry.item?.id === id);
  }
}
